import { useEffect } from 'react';
import { useShell } from '../state/shell';
import { colors } from '../theme';

/** One toast at a time, auto-dismissed. Rendered above sheets. */
export function Toaster() {
  const toast = useShell((s) => s.toast);
  const dismiss = useShell((s) => s.dismissToast);
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => dismiss(toast.id), toast.durationMs);
    return () => clearTimeout(t);
  }, [toast, dismiss]);
  if (!toast) return null;
  return (
    <div className="toast" role="status" style={{ background: toast.color ?? colors.ink }}>
      {toast.text}
    </div>
  );
}
